import React, { FC } from 'react';
import { CSSTransition } from 'react-transition-group';
import KMeeple from './KMeeple';
import { calculateRotatedPivotedNodePos } from './KTileItem';
import { getKTileStyle, getPivotStyle } from './KTileAsset';
import { getKTileDef } from '../../config/kTileMapConfig';
import { KTileDef } from '@envclient/envengine/src/envs/koenigsburg/KTileGameConfig';
import { RecoveredMeeplesDTO } from '../../types/ccson_env';
import { KTileDTO } from '@envclient/envengine/src/envs/koenigsburg/KTile';
import structuredClone from '@ungap/structured-clone';

interface RecoverMeeplesProps {
  event: RecoveredMeeplesDTO | null;
  tileData: KTileDTO[];
  onDone: () => void;
}

const RecoverMeeples: FC<RecoverMeeplesProps> = ({ event, tileData, onDone }) => {
  if (!event) return null;

  return (
    <>
      {event.recoveredMeeples.map((m) => {
        const meeple = structuredClone(m);
        meeple.recovered = false;
        // find tile for meeple, can also be tax meeple!!
        const t = tileData.filter((t) => t.id === meeple.tileId)[0];
        if (!t) return null;
        // tile offset
        const ts = getKTileStyle(t.place);
        let left: number = +ts.left.substring(0, ts.left.length - 2);
        let top: number = +ts.top.substring(0, ts.top.length - 2);
        // add meeple offset
        const tileDef: KTileDef = getKTileDef(t.type);
        const nodes = tileDef.nodes;
        const meepleNode = nodes.find((node) => node.id === meeple.nodeId);
        const pivotStyle = getPivotStyle(t.place);
        const meepleRot = +pivotStyle.transform.match(/(\d+)/)?.[0] || 0;
        const meepleOffset = calculateRotatedPivotedNodePos(meepleNode, meepleRot, t.rot, t.shape);
        left += meepleOffset.left;
        top += meepleOffset.top;
        const contStyle = { width: 40, position: 'absolute' as const, left: left + 'px', top: top + 'px' };
        return (
          <CSSTransition
            key={meeple.id}
            in={true}
            appear={true}
            timeout={1000}
            classNames="recover"
            unmountOnExit
            onEntered={onDone}>
            <div style={contStyle}>
              <KMeeple meeple={meeple} rotStyle={{}} />
            </div>
          </CSSTransition>
        );
      })}
    </>
  );
};

export default RecoverMeeples;
